module.exports = __webpack_public_path__ + "static/dmon-017-b1ac96275e223127e612cb0ce572a351.jpg";